import state from './module-acceptcheckingresult-state';
import mutations from './module-acceptcheckingresult-mutations';
import actions from './module-acceptcheckingresult-actions';
import getters from './module-acceptcheckingresult-getters';
export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
